const Promise = require('bluebird');

const Brand = {
	loadModels: brand_id => {

		return new Promise((ok, err) => {
			$.ajax({
				type: 'POST',
				url: '/api/models',
				data: {brand_id: brand_id},
				dataType: 'json',
				success: models => {
					ok(models);
				},
				error: e => {
					err(e);
				}
			});
		});

	}
}

export default Brand